import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import headerTitle from './Predict-Logo-Nav.png';
import AuthService from '../login/AuthService';
import './Header.css';

const Auth = new AuthService();

class Header extends Component {
  render() {
    return (
      <div className="Header">
        <Container>
          <Row>
            <Col lg="6" className="Header-logo" ><img src={headerTitle} alt="logo" /></Col>
            <Col lg="6" className="Header-logout"><Link to="/login"><Button className="logout-submit" onClick={this.handleLogout.bind(this)}>Log Out</Button></Link>{' '}</Col>
          </Row>
        </Container>
      </div>
    );
  }

  //clear the token from local storage
  handleLogout() {
    Auth.logout()
    localStorage.clear();
  }
}

export default Header;